











import { Vue, Component, VModel, Watch } from 'vue-property-decorator'

@Component
export default class Overlay extends Vue {
  @VModel({ type: Boolean }) isOpen!: boolean

  bScrollTop = 0

  @Watch('isOpen')
  onOpenStateToggle(value: boolean): void {
    this.toggleBackground(value)
  }

  toggleBackground(value: boolean): void {
    const body: HTMLElement = document.querySelectorAll('body')[0]
    if (value) {
      this.bScrollTop = body.scrollTop
      body.style.overflow = 'hidden'
    } else {
      body.scrollTop = this.bScrollTop
      this.bScrollTop = 0
      body.style.overflow = ''
    }
  }
}
